import { render, staticRenderFns } from "./BFilterDate.vue?vue&type=template&id=0b243550"
import script from "./BFilterDate.vue?vue&type=script&lang=js"
export * from "./BFilterDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports